import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateBasicDisplayName = mutatorAction('updateBasicDisplayName', function (displayName) {
    var store = connectedAccountsStore();
    store.connectBasicState.displayName = displayName;
});
//# sourceMappingURL=updateBasicDisplayName.js.map